import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: colors.teal,
        //secondary: '#251605',
        //accent: '#f6e27f',
        //error: '#e5c2c0',

        secondary: '#2191fb',
        accent: '#b2ece1',
        error: '#ba274a',
      },
    },
  },
});
